// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-dropzone[data-v-ffe8a04a]{min-height:126px}.dz-add-files[data-v-ffe8a04a]{padding-top:45px}.dz-uploaded-file[data-v-ffe8a04a]{cursor:default}", ""]);
// Exports
module.exports = exports;
